<template>
  <div
    @dragleave.prevent.stop="dragover = step == 1 ? false : dragover"
    @dragenter.prevent.stop="dragover = step == 1 ? true : dragover"
    @dragover.stop.prevent
    @drop.prevent="drop"
    class="flex flex-wrap content-start justify-start flex-1 gap-2 p-2"
    :class="{
      'bg-secondary/30': dragover,
      'justify-around ring-0 border-none !items-center !content-center':
        step >= 2
    }"
  >
    <template class="" v-for="result of results" :key="result.resultID + step">
      <Card
        @dragover.stop
        @selected="emitSelected"
        @report="addKnownPosition"
        :result="result"
        :selected="selected.map(x => x.id).includes(result.resultID)"
        :class="{ 'pointer-events-none': dragover }"
        :draggable="step == 1"
      />
    </template>
  </div>
</template>

<script>
import Card from "@/components/MR/Card.vue";
export default {
  name: "BoardLevel",
  components: { Card },
  props: {
    results: { type: Array, required: true },
    selected: { type: Array, required: true },
    step: { type: Number, required: true, default: 1 },
    type: { type: Number, required: true },
    level: { type: Number, required: true }
  },
  data() {
    return {
      dragover: false,
      knownPositions: []
    };
  },

  watch: {
    results(value) {
      console.log("Value changed");
      this.knownPositions = this.knownPositions.filter(x =>
        value.map(y => y.resultID).includes(x.resultID)
      );
      this.$emit("positionupdate", this.knownPositions);
    },

    step() {
      this.knownPositions = [];
    }
  },

  methods: {
    drop(e) {
      if (this.step != 1) return;
      this.dragover = false;
      const resultID = e.dataTransfer.getData("resultID");
      if (!resultID) return;
      this.$emit("droppedresult", resultID, this.type, this.level);
    },
    emitSelected(...e) {
      if (this.step != 2) return;
      this.$emit("selected", ...e);
    },
    addKnownPosition(event) {
      /*  console.log("Hello Position received");
      console.log(event); */
      this.knownPositions = [...this.knownPositions, event];
      this.$emit("positionupdate", this.knownPositions, this.level);
    }
  }
};
</script>

<style></style>
